<template>
  <div>
    <CampaignStatsOverallReportsBudget
      class="campaign-stats-overall-reports__budget"
      :is-loading="loading"
      :spent-budget="spentBudget"
      :average-spent-budget="averageSpentBudget"
      :today-spent-budget="todaySpentBudget"
    />
    <CampaignStatsOverallReportsInstall
      :is-loading="loading"
      :total-install="totalInstall"
      :average-daily-install="averageDailyInstall"
    />
  </div>
</template>

<script>
import { BasicAdsCampaigns } from '@/api/api';
import { AbortedError } from '@/api/shared/transformers/errorTransformer';
import CampaignStatsOverallReportsBudget from './CampaignStatsOverallReportsBudget';
import CampaignStatsOverallReportsInstall from './CampaignStatsOverallReportsInstall';

export default {
  name: 'CampaignStatsOverallReports',

  components: {
    CampaignStatsOverallReportsBudget,
    CampaignStatsOverallReportsInstall,
  },

  props: {
    campaignId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      averageDailyInstall: 0,
      averageSpentBudget: 0,
      spentBudget: 0,
      todaySpentBudget: 0,
      totalInstall: 0,
    };
  },

  mounted() {
    this.fetchReports();
  },

  methods: {
    fetchReports() {
      this.loading = true;

      return BasicAdsCampaigns.getCampaignReports(this.campaignId)
        .then(
          ({
            averageDailyInstall,
            averageSpentBudget,
            spentBudget,
            todaySpentBudget,
            totalInstall,
          }) => {
            this.averageDailyInstall = averageDailyInstall;
            this.averageSpentBudget = averageSpentBudget;
            this.spentBudget = spentBudget;
            this.todaySpentBudget = todaySpentBudget;
            this.totalInstall = totalInstall;
          },
        )
        .catch(error => {
          if (error instanceof AbortedError) return;
          const { message } = error;
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.campaign-stats-overall-reports {
  &__budget {
    margin-bottom: 2 * $global-margin;
  }
}
</style>
